module.exports = __webpack_public_path__ + "static/1320221438.c102178e.jpg";